import { render, staticRenderFns } from "./TwoRowsLayout.vue?vue&type=template&id=3fc3cc64&"
import script from "./TwoRowsLayout.vue?vue&type=script&lang=js&"
export * from "./TwoRowsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports